import { useForm, useFormField, useValidator } from '../modules/forms';

export interface LoyaltyCardFormData {
  readonly loyaltyCardNumber: string;
}

export interface LoyaltyCardFormOptions {
  /**
   * Disable changing the loyalty card number.
   */
  readonly disabled?: boolean;

  /**
   * Initial data to populate the form with.
   */
  readonly initialData?: LoyaltyCardFormData;
}

export function useAccountLoyaltyCardForm(
  onSubmit: (data: LoyaltyCardFormData) => void,
  { initialData, disabled = true }: LoyaltyCardFormOptions,
) {
  const loyaltyCardNumberChangeDisabledValidator = useValidator(() => {
    return disabled
      ? ('validation_error.loyalty_card_number_change_disabled' as const)
      : null;
  }, [disabled]);

  const loyaltyCardNumber = useFormField({
    value: initialData?.loyaltyCardNumber ?? '',
    required: false,
    disabled,
    validators: [loyaltyCardNumberChangeDisabledValidator],
  });

  const form = useForm({
    fields: {
      loyaltyCardNumber,
    },
    onSubmit,
  });

  return form;
}
